<template>
  <v-textarea
    class="pulse-input pulse-textarea"
    outlined
    dense
    :hide-details="!hasErrors"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: "PulseTextarea",
  inheritAttrs: false,
  computed: {
    hasErrors() {
      const errors = this.$attrs["error-messages"];
      return Array.isArray(errors) ? errors.length > 0 : !!errors;
    },
  },
};
</script>
